import React from 'react'

import PropTypes from 'prop-types'
import {Button, Form, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';

class LoginWidget extends React.Component{
  constructor(props) {
    super(props);
    this.state = {      
      username: '',
      password: '',
      rememberMe: true,
      agentLogin: props.agentLogin,
      formClass: props.formClass || 'loginWidget',
      onLogin: props.onLogin,
      onChangeAgent: props.onChangeAgent,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeAgent = this.handleChangeAgent.bind(this);
  }
  
  handleChangeAgent = (selectedOption) => {      
    var newAgent= (selectedOption ? selectedOption.value : null)    
    this.setState({ 
      agentLogin: newAgent,
    })
    this.state.onChangeAgent(newAgent)
    //alert (newAgent)
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
    //console.log(name + ' -> ' + value);
  }
  handleSubmit(event) {
    event.preventDefault();    
    this.state.onLogin(this.state);     
  }
  
  render() {
    if (this.props.isLogged)
      return this.renderLogged();
    else //niezalogowany
      return this.renderNotLogged();
  }
  
  renderLogged(){
    return  (
      <div className={this.state.formClass}>
        <Form  onSubmit={this.handleAgentChangeX}>     
          {this.props.userFullName + ' '}
          {this.renderAgent()}         
          {' '}
          <Button 
              size="sm" 
              color="warning"
              id="btnLogout" onClick={this.props.onLogout}
              type="submit"
            >
              Wyloguj
            </Button>                           
        </Form>
      </div>
    )  
  }
  renderAgent() {
    if (this.props.agents.length>1){
      return (
        <Select
            id="state-select"              
            autoFocus
            options={this.props.agents.map(pos => ({value: pos.LoginName, label: pos.ShortName}))}
            name="criteria"              
            value={this.props.agentLogin}
            placeholder="Wybierz agenta"
            onChange={this.handleChangeAgent}              
            openOnClick={true}
            searchable={true}
            clearable={false} 
            className="agentSelect"           
          />
        )
    }      
    else
        return '(agent: ' + this.props.agentFullName + ') '
  }
  renderNotLogged() {        
    return (
      <div className={this.state.formClass}>
        <Form  onSubmit={this.handleSubmit}>          
          <InputGroup size="sm">
            <InputGroupAddon>@</InputGroupAddon>
            <Input type="email" 
              name="username" 
              placeholder="e-mail użytkownika"
              required              
              onChange={this.handleInputChange}              
            />
          </InputGroup>
                    
          <InputGroup size="sm">
            <InputGroupAddon>?</InputGroupAddon>
            <Input type="password" 
              value={this.state.password} 
              placeholder="hasło użytkownika" 
              name="password" 
              required 
              onChange={this.handleInputChange}       
              size="sm"
            />
          </InputGroup>
          <Button size="sm" color="success">Zaloguj</Button>
        </Form>
      </div>
    )
  }  
}

LoginWidget.propTypes={  
  isLogged: PropTypes.bool,
  userFullName: PropTypes.string,
  //onLogin: PropTypes.function,
  //onLogout: PropTypes.function,
}

export default LoginWidget;


// WEBPACK FOOTER //
// ./src/components/LoginWidget.js